export let removeFromFavoritesText = "Een6zc";
export default {removeFromFavoritesText};